import React, { FC } from "react";
import FlexBox from "../../components/FlexBox";
import ExpiredTestIcon from "../../assets/svg/file-expired.svg";
import { Theme, useMediaQuery } from "@mui/material";
import { H2 } from "../../components/Typography";

export const ExpirePsychTest: FC = () => {
  const downSm = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  return (
    <FlexBox
      data-aos="fade-up"
      data-aos-duration="800"
      sx={{
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        height: { sm: "100%" },
        padding: "20px",
      }}
    >
      <img
        width={downSm ? 150 : 300}
        src={ExpiredTestIcon}
        alt="expired-test"
      />
      <H2 sx={{ textAlign: "center", fontSize: downSm ? "14px" : "18px" }}>
        Your Psychometric test has expired!
      </H2>
    </FlexBox>
  );
};
